import { Text } from "../../../../components/Text"
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { blockUnblockChat, deleteChat } from "../../../../reducers/enqChatSlice";
const UnblockChat = () => {
    const { user } = useSelector(state => state.enqChats)
    const dispatch = useDispatch();

    const handleUnBlockChat = () => {
        const payload = {
            customerMobile: user.phone,
            blockStatus: "unblock",
        }
        dispatch(blockUnblockChat(payload))
    }

    const handleDeleteChat = () => {
        dispatch(deleteChat(user.phone))
    }

    return <div className="w-full p-3 text-center">
        <Text type={'heading'}>You blocked this contact, click to unblock. </Text>
        <div className="flex gap-4 mt-2 justify-content-center">
            <Button label="Delete" severity="danger" icon='pi pi-trash' onClick={handleDeleteChat} text rounded />
            <Button label="Unblock" icon="pi pi-ban" severity="secondary" onClick={handleUnBlockChat} text rounded />
        </div>
    </div>
}

export default UnblockChat;